import(/* webpackMode: "eager" */ "/var/www/nextjs-preview/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["AboutPublicPage"] */ "/var/www/nextjs-preview/src/components/about/AboutPublicPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/nextjs-preview/src/components/platform/HubeeHomePage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StartView"] */ "/var/www/nextjs-preview/src/components/start/StartView.tsx");
